import * as PIXI from "pixi.js";
import Layers from "../../../layers/Layers";
import RulerRendererFactory from "./RulerRendererFactory";
import { Coord } from "../../../types/Interface";
import genCoordFromAngle from "../../../utils/coord/genCoordFromAngle";
import getCleanCoord from "../../../utils/coord/getCleanCoord";
import getDistanceBtwPoints from "../../../utils/getDistanceBtwPoints";
import getAngleBetweenPoints from "../../../utils/math/getAngleBtwPoints";


const RULER_CM_AMOUNT = 15;


export default class RulerRenderer extends PIXI.Container {
  private Layers = Layers.getInstance();
  private bg = this.addChild(new PIXI.Graphics());
  private graduations = this.addChild(new PIXI.Graphics());
  private numbers: PIXI.Text[] = Array(RULER_CM_AMOUNT + 1).fill(null).map(() => this.addChild(new PIXI.Text()));

  public drawingArea = this.addChild(new PIXI.Graphics());
  public backDrawingArea = this.addChild(new PIXI.Graphics())
  public grabButton = this.addChild(new PIXI.Graphics());
  public flipButton = this.addChild(new PIXI.Graphics());
  public rotateRightButton = this.addChild(new PIXI.Graphics());
  public rotateLeftButton = this.addChild(new PIXI.Graphics());

  constructor() {
    super();
    this.addToLayer();
    this.deactiveEventMode();
  }
  private addToLayer = () => this.Layers.UITop.addChild(this);
  private deactiveEventMode = () => [this.bg, this.graduations, ...this.numbers].forEach(elm => elm.eventMode = 'none');

  getGraduationBounds(isBack: boolean): { start: Coord, end: Coord } {
    const w = this.graduations.width;
    const glb = this.graduations.getGlobalPosition();
    const _pstn = RulerRendererFactory.getGraduationCoord(0, RULER_CM_AMOUNT, isBack);
    const __startCoord = getCleanCoord({ x: glb.x + _pstn.x, y: glb.y + _pstn.y });
    const distance = getDistanceBtwPoints(__startCoord, glb);
    const rad1 = getAngleBetweenPoints(__startCoord, glb);
    const _startCoord = genCoordFromAngle(this.rotation + Math.PI + rad1, distance);
    const _endCoord = genCoordFromAngle(this.rotation, w);

    const start = getCleanCoord({ x: glb.x + _startCoord.x, y: glb.y + _startCoord.y });
    const end = getCleanCoord({ x: start.x + _endCoord.x, y: start.y + _endCoord.y });
    return { start, end };
  }
  draw() {
    RulerRendererFactory.drawBg(this.bg, RULER_CM_AMOUNT);
    RulerRendererFactory.drawgraduations(this.graduations, RULER_CM_AMOUNT);
    RulerRendererFactory.drawNumbers(this.numbers, RULER_CM_AMOUNT);
    RulerRendererFactory.drawFlipButton(this.flipButton);
    RulerRendererFactory.drawRotateButton(this.rotateRightButton, false, RULER_CM_AMOUNT);
    RulerRendererFactory.drawRotateButton(this.rotateLeftButton, true, RULER_CM_AMOUNT);
    RulerRendererFactory.drawGrabButton(this.grabButton, RULER_CM_AMOUNT);
    RulerRendererFactory.drawDrawingArea(this.drawingArea, RULER_CM_AMOUNT, false);
    RulerRendererFactory.drawDrawingArea(this.backDrawingArea, RULER_CM_AMOUNT, true);
  }
}